/* eslint-disable camelcase */
import React, { memo } from 'react';

import cx from 'classnames';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { getFormattedVolume } from 'helpers/utils';
import { statsSelector } from 'selectors';
import { useAppSelector } from 'storeHooks';

// import { VolumeIcon } from 'styles/assets/icons';
import styles from './volume.module.scss';

const FuturesVolumeBox = ({ withBg }: { withBg?: boolean }) => {
  const allStats = useAppSelector(statsSelector);
  const futures_last_24h_volume =
    allStats.futures && allStats.futures.last_24h_volume
      ? allStats.futures.last_24h_volume
      : null;

  const { t } = useTranslation(['markets']);

  return (
    (<div
      className={cx(styles.totalVolumeBox, {
        [styles.coloredBox]: withBg,
      })}
      data-palette="FuturesVolumeBox">
      {/* <VolumeIcon /> */}
      <span>
        <span className={styles.secondaryText}>
          24 hr {t('markets:marketsTable.volume')}
        </span>
        {futures_last_24h_volume === null || futures_last_24h_volume === 0
          ? ' ---'
          : ` $${getFormattedVolume(isMobile)(futures_last_24h_volume)}`}
      </span>
    </div>)
  );
};

export default memo(FuturesVolumeBox);
